import { C } from './constants';

/**
 * SVG line chart with gradient fill area.
 * Shows score trajectory over time.
 *
 * @param {{ d: string, s: number }[]} data - Array of { d: label, s: score }
 * @param {number} [min=70] - Y-axis minimum
 * @param {number} [max=100] - Y-axis maximum
 * @param {string} [gradientId='slam-trend-grad'] - Unique SVG gradient ID
 */
export const TrendChart = ({ data, min: mn = 70, max: mx = 100, gradientId = 'slam-trend-grad' }) => {
  const h = 100, w = 300;
  const pts = data.map((d, i) => ({
    x: 30 + (i / (data.length - 1)) * (w - 60),
    y: h - 10 - ((d.s - mn) / (mx - mn)) * (h - 30),
  }));
  const path = pts.map((p, i) => `${i === 0 ? 'M' : 'L'}${p.x},${p.y}`).join('');

  const gridLines = [];
  for (let v = mn + 5; v <= mx; v += 5) gridLines.push(v);

  return (
    <svg width="100%" viewBox={`0 0 ${w} ${h + 10}`}>
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={C.gold} stopOpacity=".15" />
          <stop offset="100%" stopColor={C.gold} stopOpacity="0" />
        </linearGradient>
      </defs>

      {gridLines.map((v) => {
        const y = h - 10 - ((v - mn) / (mx - mn)) * (h - 30);
        return (
          <g key={v}>
            <line x1={30} y1={y} x2={w - 30} y2={y} stroke={C.border} strokeWidth="0.5" />
            <text x={22} y={y + 3} textAnchor="end" fill={C.t3} fontSize="7">{v}</text>
          </g>
        );
      })}

      <path d={`${path}L${pts[pts.length - 1].x},${h - 5}L${pts[0].x},${h - 5}Z`} fill={`url(#${gradientId})`} />
      <path d={path} fill="none" stroke={C.gold} strokeWidth="1.5" />

      {pts.map((p, i) => (
        <g key={i}>
          <circle cx={p.x} cy={p.y} r="3" fill={C.bg} stroke={C.gold} strokeWidth="1.5" />
          <text x={p.x} y={p.y - 10} textAnchor="middle" fill={C.text} fontSize="9" fontWeight="500">{data[i].s}</text>
          <text x={p.x} y={h + 8} textAnchor="middle" fill={C.t3} fontSize="7">{data[i].d}</text>
        </g>
      ))}
    </svg>
  );
};
